export default "__VITE_ASSET__CMGPb9YQ__"